module.exports = __webpack_public_path__ + "static/mind-mate-cover-8797aec7a6ccedf19e7201e33c6c9bd9.png";